import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Tag Manager component for tracking route changes in React Router
 * This ensures GTM tracks page views for single-page application navigation
 */
const GoogleTagManager = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if dataLayer exists (GTM is loaded)
    if (typeof window !== "undefined" && window.dataLayer) {
      // Push page view event to GTM dataLayer
      window.dataLayer.push({
        event: "page_view",
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleTagManager;
